import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { useWindowSize } from 'react-use';
import '../../../../../constants/modelCompareData/assets/arrow-right.svg.mjs';
import { useModelCompareTranslation } from '../../../../../constants/modelCompareData/translations/useModelCompareTranslation.mjs';
import '../../../../StyleableSvgImage/index.mjs';
import { MOBILE_BREAKPOINT } from '../../../CompareTable/CompareTable.styles.mjs';
import { Button, Icon } from './ScrollButton.styles.mjs';
import arrowRightIcon__default from "../../../../../assets/arrowRight.svg";
import { StyleableSvgImage } from '../../../../StyleableSvgImage/StyleableSvgImage.mjs';
"use strict";
const icon = typeof arrowRightIcon__default === "string" ? arrowRightIcon__default : arrowRightIcon__default.src;
const ScrollButton = ({
  color,
  rotationDegrees,
  isVisible,
  isRightButton,
  onClick
}) => {
  const {
    width: screenWidth
  } = useWindowSize();
  const isSmallScreen = screenWidth < MOBILE_BREAKPOINT;
  const placeButtonsOverCards = screenWidth < 1450;
  const {
    formatMessage
  } = useModelCompareTranslation();
  const arrowOffset = useMemo(() => {
    if (isSmallScreen) {
      return rotationDegrees < 180 ? -5 : 0;
    }
    return -15;
  }, [isSmallScreen, rotationDegrees]);
  return /* @__PURE__ */jsx(Button, {
    "aria-label": isRightButton ? formatMessage("commons.scrollButton.right") : formatMessage("commons.scrollButton.left"),
    $color: color,
    $rotation: rotationDegrees,
    $isVisible: isVisible,
    $isRightButton: Boolean(isRightButton),
    $placeButtonsOverCards: placeButtonsOverCards,
    type: "button",
    onClick,
    children: /* @__PURE__ */jsx(Icon, {
      rotation: rotationDegrees,
      arrowOffset,
      children: /* @__PURE__ */jsx(StyleableSvgImage, {
        width: 10,
        height: 16,
        src: icon
      })
    })
  });
};
export { ScrollButton };
//# sourceMappingURL=ScrollButton.mjs.map
